package com.schoolconnect.app.datasource.network.response

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class QuickMarkDataResponse(
    @SerialName("class_section_id") val classSectionId: String? = null,
    @SerialName("attendance_date") val attendanceDate: String? = null,
    val count: Int? = null,
    val students: List<QuickMarkStudentResponse>? = null
)

@Serializable
data class QuickMarkStudentResponse(
    @SerialName("student_id") val studentId: String? = null,
    @SerialName("roll_number") val rollNumber: String? = null,
    @SerialName("student_name") val studentName: String? = null,
    val attendance: QuickMarkExistingAttendanceResponse? = null
)

@Serializable
data class QuickMarkExistingAttendanceResponse(
    @SerialName("attendance_id") val attendanceId: String? = null,
    val status: String? = null,
    val remarks: String? = null
)
